export const authSelector = (state) => state.auth.auth
export const staffSelector = (state) => state.staff
export const customerSelector = (state) => state.customer
export const tourTypeSelector = (state) => state.tourType
export const newsCategoriesSelector = (state) => state.newsCategories
export const newsSelector = (state) => state.news
export const tourSelector = (state) => state.tour
export const searchSelector = (state) => state.search
export const homeSelector = (state) => state.home
export const tourDetailSelector = (state) => state.tourDetail
export const tourOrderSelector = (state) => state.tourOrder
export const favoriteSelector = (state) => state.favorite
export const rattingCommentSelector = (state) => state.rattingComment
export const commentSelector = (state) => state.comment
